import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'bb-infinite-scroll-page-ui',
    templateUrl: './bb-infinite-scroll-page-ui.component.html',
    styles: [],
    standalone: false,
})
export class InfiniteScrollPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
